import React from 'react';
import PropTypes from 'prop-types';
import GroupBookingSeatSelection from './GroupBookingSeatSelection';
import PageNavigation from './PageNavigation';

const GroupBookingSeatDetails = ({ selectedSeats, ...selectedSeatsProps }) => {
  const itemsPerPage = 20;
  const totalNumberOfPages = Math.ceil(selectedSeats.length / itemsPerPage);

  return (
    <PageNavigation itemsPerPage={itemsPerPage} totalNumberOfPages={totalNumberOfPages}>
      {({ getItemsToShow }) => (
        <GroupBookingSeatSelection
          {...{
            selectedSeats,
            ...selectedSeatsProps
          }}
          seatsToShow={getItemsToShow(selectedSeats)}
        />
      )}
    </PageNavigation>
  );
};

GroupBookingSeatDetails.propTypes = {
  selectedSeats: PropTypes.arrayOf(
    PropTypes.shape({
      passenger: PropTypes.shape({
        id: PropTypes.string
      }),
      number: PropTypes.string,
      coach: PropTypes.string
    })
  ),
  onSelectNewPassenger: PropTypes.func,
  selectedPassenger: PropTypes.shape({
    id: PropTypes.string
  }),
  onRemovePassengerSelection: PropTypes.func
};

export default GroupBookingSeatDetails;
